import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { EyeIcon } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { ChatBubbleBottomCenterIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useToggle } from "react-use";
import { BusinessReportOutcomeDeleteModal } from "@/modules/snapshots/modals/businessReportOutComeDeleteModal";

interface Props {
  businessReportOutcome: BusinessReportOutcome;
}

export const SnapshotCollectionsOutcomesRowActions: React.FC<Props> = ({ businessReportOutcome }) => {
  const [showRemoveModal, setShowRemoveModal] = useToggle(false);
  if (!businessReportOutcome.fs_entry) {
    return null;
  }
  return (
    <>
      <BusinessReportOutcomeDeleteModal
        businessReportOutcome={businessReportOutcome}
        isOpen={showRemoveModal}
        setIsOpen={setShowRemoveModal}
      />
      <div className="flex justify-end pr-2">
        <Link to={`/reports/outcome/${businessReportOutcome.id}`} title="View SnapShot">
          <Button
            disabled={businessReportOutcome.status === "NEW"}
            variant="secondary"
            size="sm"
            className="mr-1 flex items-center gap-2 px-3 py-2 text-xs"
            type="button"
          >
            <EyeIcon className="h-4 w-4 flex-shrink-0" /> View
          </Button>
        </Link>

        <Button variant="secondary" size="sm" className="mr-1 w-full text-xs sm:w-auto" asChild>
          <Link to={`/chat/${businessReportOutcome.fs_entry.id}`}>
            <ChatBubbleBottomCenterIcon className="mr-2 h-4 w-4" />
            Q&A
          </Link>
        </Button>

        <Button
          variant="secondary"
          size="sm"
          className="flex items-center gap-2 px-3 py-2 text-xs"
          type="button"
          onClick={setShowRemoveModal}
        >
          <TrashIcon className="h-4 w-4 flex-shrink-0" />
        </Button>
      </div>
    </>
  );
};
